function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "white"
    },
    d: "M24.1667 3.625H4.83333C4.51286 3.625 4.20552 3.75231 3.97891 3.97891C3.75231 4.20552 3.625 4.51286 3.625 4.83333V24.1667C3.625 24.4871 3.75231 24.7945 3.97891 25.0211C4.20552 25.2477 4.51286 25.375 4.83333 25.375H15.2431V16.965H12.418V13.6723H15.2431V11.2556C15.2431 8.44625 16.959 6.91529 19.4723 6.91529C20.3169 6.91288 21.1627 6.95638 22.0037 7.04458V9.96875H20.2698C18.9068 9.96875 18.641 10.6188 18.641 11.5698V13.6663H21.8998L21.4769 16.959H18.6398V25.375H24.1667C24.4871 25.375 24.7945 25.2477 25.0211 25.0211C25.2477 24.7945 25.375 24.4871 25.375 24.1667V4.83333C25.375 4.51286 25.2477 4.20552 25.0211 3.97891C24.7945 3.75231 24.4871 3.625 24.1667 3.625Z",
    fill: "black"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookDark);
export default __webpack_public_path__ + "static/media/facebookDark.40d75bc8fba077c928bbe36fecf1148e.svg";
export { ForwardRef as ReactComponent };